import { API_MAP } from './apiMap';
import axios from 'axios';
import { BASE_URL } from '.';
export const request = async (api, { method, query, params, body }, isAbsolute = false) => {
  const url = `${BASE_URL}${isAbsolute ? api : API_MAP[api]}${params ? '/' + params : ''}`;

  const headers = {
    'Content-Type': 'application/json',
  };
  const user = JSON.parse(localStorage.getItem('user'));
  const token = user?.token; // safely access user.token
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  try {
    const response = await axios({
      method,
      url,
      params: query,
      data: body,
      headers
    });
    return response.data;
  } catch (err) {
    console.log(err);
    return err.response.data;
  }
};
